import React from 'react';
import {Link} from 'react-router-dom';



function InternalMedicineBreadCumb() {
  return (
	  <section className="breadcrumb-area breadcrumb-bg" style={{ backgroundImage:'url("img/services/breadcrumb_bg3.jpg")'}}>
        <div className="container animated animatedFadeInUp fadeInUp">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-content">
                <h2 className="title">Veterinary Internal Medicine</h2>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/Services">Services</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Internal Medicine</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
  )
}

export default InternalMedicineBreadCumb;
